import { DriveStep } from "driver.js";

export const tourStepsConfigAdmin: Record<string, DriveStep[]> = {
  "/dashboard": [
    {
      element: '[data-tour="dashboard"]',
      popover: {
        title: "Dashboard",
        description: `
  <p>The <strong>Dashboard</strong> serves as your central hub for both system configuration and performance analytics.</p>
  <p>in addition to configuration, the dashboard provides a visual overview of key metrics:</p>
  <ul style="padding-left: 20px; margin: 0;">
    <li><strong>Total responses</strong> – monitor the number of survey responses collected over time.</li>
    <li><strong>Forms published</strong> – track how many survey forms have been published to date.</li>
    <li><strong>Average completion time</strong> – analyze how long users typically take to complete surveys.</li>
    <li><strong>Published forms list</strong> – view a list of all forms that have been published so far.</li>
  </ul>
`,
      },
    },
    {
      element: '[data-tour="user-management"]',
      popover: {
        title: "User management",
        description: `
  <p>the <strong>User management </strong> section allows you to configure core entities that are used throughout the application. You can manage and customize the following:</p>
  <ul style="padding-left: 20px; margin: 0;">
    <li><strong>Users</strong> – define different roles or classifications for system users.</li>
    <li><strong>Departments</strong> – organize users by department for better structure and reporting.</li>
    <li><strong>Designations</strong> – specify job titles or positions assigned to users.</li>
    <li><strong>Locations</strong> – maintain a list of physical or organizational locations where users are based.</li>
  <li><strong>Classification</strong> – maintain a list of classification for user's</li>
  </ul>
  
`,
      },
    },
    {
      element: '[data-tour="master"]',
      popover: {
        title: "Masters",
        description: `
  <p>The <strong>masters</strong> section provides access to essential configurations that power various parts of the application. These master settings are foundational and ensure consistency across the system.</p>
  <p>you can manage the following from here:</p>
  <ul style="padding-left: 20px; margin: 0;">
    <li><strong>Organizations</strong> – add and manage organizational entities within your application structure.</li>
    <li><strong>Email templates</strong> – create and customize email formats used for automated communications.</li>
    <li><strong>Assessment types</strong> – define types of assessments to categorize surveys and evaluations.</li>
    <li><strong>Question categories</strong> – organize questions into logical categories for better survey management.</li>
  </ul>
  
`,
      },
    },
    {
      element: '[data-tour="question-bank"]',
      popover: {
        title: "Question bank",
        description:
          "Access and manage the collection of predefined questions used in survey forms.",
      },
    },
    {
      element: '[data-tour="survey-forms"]',
      popover: {
        title: "Forms",
        description: `
        <p>The <strong>forms</strong> section allows you to create, manage, and organize various types of interactive content within the application.</p>
        <p>from this dropdown, you can access:</p>
        <ul style="padding-left: 20px; margin: 0;">
          <li><strong>Forms</strong> – design and manage customizable survey forms used to collect structured feedback or information.</li>
          <li><strong>Quiz</strong> – create quizzes for assessments with scoring, correct answers, and result tracking.</li>
          <li><strong>Poll</strong> – launch quick polls to gather opinions or make decisions through simple voting.</li>
        </ul>
        <p>this section helps you build engaging and insightful content tailored to your organization's needs.</p>
      `,
      },
    },
    {
      element: '[data-tour="survey-assignments"]',
      popover: {
        title: "Assigments",
        description: `
  <p>The <strong>assignments</strong> section allows you to distribute various types of content to users for participation or evaluation.</p>
  <p>you can manage the following assignments from this dropdown:</p>
  <ul style="padding-left: 20px; margin: 0;">
    <li><strong>Form assignments</strong> – assign survey forms to users or groups for structured data collection.</li>
    <li><strong>Quiz assignments</strong> – allocate quizzes for assessments, enabling scoring and performance tracking.</li>
    <li><strong>Poll assignments</strong> – share polls with users to quickly gather opinions or make decisions.</li>
  </ul>
  <p>use this section to effectively deliver interactive content and monitor user engagement across different formats.</p>
`,
      },
    },
    {
      element: '[data-tour="reports"]',
      popover: {
        title: "Reports",
        description: `
        <p>View and analyze survey reports and insights.</p>
        <ul style="padding-left: 20px; margin: 0;">
          <li><strong>Response analysis report</strong> – review detailed responses collected from forms, quizzes, and polls.</li>
          <li><strong>Sentiment analysis report</strong> – analyze the emotional tone of textual responses using sentiment scoring.</li>
          <li><strong>Markable response report</strong> – track and evaluate responses for markable (scored) questions.</li>
          <li><strong>Comparison report</strong> – compare performance or feedback across multiple users, groups, or assignments.</li>
          <li><strong>Cross tab report</strong> – explore relationships between two or more variables in the response data.</li>
          <li><strong>Trend report</strong> – identify patterns and trends over time based on user submissions.</li>
        
        </ul>
        
      `,
      },
    },
    {
      element: '[data-tour="settings"]',
      popover: {
        title: "Settings",
        description:
          "Configure application settings and preferences from here.",
      },
    },
    {
      element: '[data-tour="template"]',
      popover: {
        title: "Template",
        description:
          "Create and manage reusable templates for survey form. Templates help maintain consistency and save time by predefining layouts and questions for future use",
      },
    },
  ],
  "/users": [
    {
      element: '[data-tour="upload-user"]',
      popover: {
        title: "Upload user excel",
        description: "Click here to upload excel for user bulk import",
      },
    },
    {
      element: '[data-tour="download-tempelate"]',
      popover: {
        title: "Template for importing user",
        description: "Click here to download template.",
      },
    },
    {
      element: '[data-tour="add-user"]',
      popover: {
        title: "Add user",
        description: "Click here to add user",
      },
    },

    {
      element: '[data-tour="edit-user"]',
      popover: {
        title: "Update user",
        description: "Click here to update user",
      },
    },
    {
      element: '[data-tour="delete-user"]',
      popover: {
        title: "Delete user",
        description: "Click here to delete user",
      },
    },
    {
      element: '[data-tour="download-data"]',
      popover: {
        title: "Export data in excel",
        description: "Download data for this list page",
      },
    },

    {
      element: '[data-tour="search-user"]',
      popover: {
        title: "Search user",
        description: "Click here to search user",
      },
    },
  ],
  "/users-add": [
    {
      element: '[data-tour="add-user"]',
      popover: {
        title: "Add user",
        description: "Click here to add user",
      },
    },
  ],
  "/users/add": [
    {
      element: '[data-tour="fill-user-information"]',
      popover: {
        title: "Fill user",
        description:
          "Provide the user's key personal and professional detail's required",
      },
    },
    {
      element: '[data-tour="save-user-info"]',
      popover: {
        title: "Save user",
        description: "Click here to save/update user",
      },
    },
  ],
  "/users/edit": [
    {
      element: '[data-tour="fill-user-information"]',
      popover: {
        title: "Update user",
        description:
          "update the user's key personal and professional information required",
      },
    },
    {
      element: '[data-tour="save-user-info"]',
      popover: {
        title: "Update user",
        description: "Click here to update user",
      },
    },
  ],
  "/user-department": [
    {
      element: '[data-tour="add-department"]',
      popover: {
        title: "Add department",
        description: "Click here to add department",
      },
    },
    {
      element: '[data-tour="edit-department"]',
      popover: {
        title: "Update department",
        description: "Click here to update department",
      },
    },
    {
      element: '[data-tour="delete-department"]',
      popover: {
        title: "Delete department",
        description: "Click here to delete department",
      },
    },
    {
      element: '[data-tour="search-department"]',
      popover: {
        title: "Search department",
        description: "Click here to search department",
      },
    },
    {
      element: '[data-tour="download-data"]',
      popover: {
        title: "Download department data",
        description: "Click here to download department data.",
      },
    },
  ],
  "/user-department-add": [
    {
      element: '[data-tour="add-department"]',
      popover: {
        title: "Add department",
        description: "Click here to add department",
      },
    },
  ],
  "/user-classification": [
    {
      element: '[data-tour="add-classification"]',
      popover: {
        title: "Add classification",
        description: "Click here to add classification",
      },
    },
    {
      element: '[data-tour="edit-classification"]',
      popover: {
        title: "Update classification",
        description: "Click here to update classification",
      },
    },
    {
      element: '[data-tour="delete-classification"]',
      popover: {
        title: "Delete classification",
        description: "Click here to delete classification",
      },
    },
    {
      element: '[data-tour="search-classification"]',
      popover: {
        title: "Search classification",
        description: "Click here to search classification",
      },
    },
    {
      element: '[data-tour="download-data"]',
      popover: {
        title: "Download classification data",
        description: "Click here to download classification data.",
      },
    },
  ],
  "/user-classification-add": [
    {
      element: '[data-tour="add-classification"]',
      popover: {
        title: "Add classification",
        description: "Click here to add classification",
      },
    },
  ],
  "/user-designation": [
    {
      element: '[data-tour="add-designation"]',
      popover: {
        title: "Add designation",
        description: "Click here to add designation",
      },
    },
    {
      element: '[data-tour="edit-designation"]',
      popover: {
        title: "Update designation",
        description: "Click here to update designation",
      },
    },
    {
      element: '[data-tour="delete-designation"]',
      popover: {
        title: "Delete designation",
        description: "Click here to delete designation",
      },
    },
    {
      element: '[data-tour="search-designation"]',
      popover: {
        title: "Search designation",
        description: "Click here to search classification",
      },
    },
    {
      element: '[data-tour="download-data"]',
      popover: {
        title: "Download designation data",
        description: "Click here to download designation data.",
      },
    },
  ],
  "/user-designation-add": [
    {
      element: '[data-tour="add-designation"]',
      popover: {
        title: "Add designation",
        description: "Click here to add designation",
      },
    },
  ],
  "/location": [
    {
      element: '[data-tour="add-location"]',
      popover: {
        title: "Add location",
        description: "Click here to add location",
      },
    },
    {
      element: '[data-tour="edit-location"]',
      popover: {
        title: "Update location",
        description: "Click here to update location",
      },
    },
    {
      element: '[data-tour="delete-location"]',
      popover: {
        title: "Delete location",
        description: "Click here to delete location",
      },
    },
    {
      element: '[data-tour="search-location"]',
      popover: {
        title: "Search location",
        description: "Click here to search location",
      },
    },
    {
      element: '[data-tour="download-data"]',
      popover: {
        title: "Download location data",
        description: "Click here to download location data.",
      },
    },
  ],
  "/location-add": [
    {
      element: '[data-tour="add-location"]',
      popover: {
        title: "Add location",
        description: "Click here to add location",
      },
    },
  ],
  "/organizations": [
    {
      element: "[data-tour=edit-organization]",
      popover: {
        title: "Edit organization",
        description: "Click here to edit organization",
      },
    },
    {
      element: "[data-tour=search-Organization]",
      popover: {
        title: "Search organization",
        description: "Click here to search organization",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download organization data",
        description: "Click here to download organization data.",
      },
    },
  ],
  "/organizations/add": [
    {
      element: '[data-tour="fill-organization-information"]',
      popover: {
        title: "Fill organization details",
        description:
          "Provide the organization's basic details to set up and register it in the system.",
      },
    },

    {
      element: "[data-tour=save-organization-info]",
      popover: {
        title: "Save organization infomation",
        description: "Click here to save organization",
      },
    },
  ],
  "/organizations/edit": [
    {
      element: '[data-tour="fill-organization-information"]',
      popover: {
        title: "Update organization",
        description:
          "Update the organization's basic detail to set up and register it in the system.",
      },
    },

    {
      element: "[data-tour=save-organization-info]",
      popover: {
        title: "Update organization infomation",
        description: "Click here to update organization",
      },
    },
  ],
  "/tempelate": [
    {
      element: "[data-tour=edit-template]",
      popover: {
        title: "Edit templates",
        description: "Click here to edit templates",
      },
    },
    {
      element: "[data-tour=search-template]",
      popover: {
        title: "Search templates",
        description: "Click here to search templates",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download templates data",
        description: "Click here to download templates data.",
      },
    },
  ],
  "/tempelate/add": [
    {
      element: '[data-tour="save-template-info"]',
      popover: {
        title: "Save template",
        description: "Click here to save template",
      },
    },
  ],
  "/tempelate/edit": [
    {
      element: '[data-tour="fill-template-information"]',
      popover: {
        title: "Update template",
        description:
          "Update the template's basic detail's to set up and register it in the system.",
      },
    },
    {
      element: '[data-tour="save-template-info"]',
      popover: {
        title: "Update template",
        description: "Click here to update template",
      },
    },
  ],
  "/assessment-types": [
    {
      element: "[data-tour=add-assessment]",
      popover: {
        title: "Add assessment",
        description: "Click here to add assessment type",
      },
    },
    {
      element: "[data-tour=edit-assessment]",
      popover: {
        title: "Update assessment",
        description: "Click here to update assessment",
      },
    },
    {
      element: "[data-tour=delete-assessment]",
      popover: {
        title: "Delete assessment",
        description: "Click here to delete assessment",
      },
    },
    {
      element: "[data-tour=search-assessment]",
      popover: {
        title: "Search assessment",
        description: "Click here to search assessment",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download assessment data",
        description: "Click here to download assessment data.",
      },
    },
  ],
  "/assessment-types-add": [
    {
      element: "[data-tour=add-assessment]",
      popover: {
        title: "Add assessment",
        description: "Click here to add assessment ",
      },
    },
  ],
  "/question-types": [
    {
      element: "[data-tour=add-question-types]",
      popover: {
        title: "Add question types",
        description: "Click here to add question-types",
      },
    },
    {
      element: "[data-tour=edit-question-types]",
      popover: {
        title: "Update question types",
        description: "Click here to update question-types",
      },
    },
    {
      element: "[data-tour=delete-question-types]",
      popover: {
        title: "Delete question types",
        description: "Click here to delete question-types",
      },
    },
    {
      element: "[data-tour=search-question-types]",
      popover: {
        title: "Search question types",
        description: "Click here to search assessment",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download question types",
        description: "Click here to download question-types data.",
      },
    },
  ],
  "/question-types-add": [
    {
      element: "[data-tour=add-question-types]",
      popover: {
        title: "Add question types",
        description: "Click here to add question-types",
      },
    },
  ],
  "/questions": [
    {
      element: '[data-tour="upload-questions"]',
      popover: {
        title: "Upload question excel",
        description: "Click here to upload excel for question bulk import",
      },
    },
    {
      element: '[data-tour="download-question-tempelate"]',
      popover: {
        title: "Template for importing question",
        description: "Click here to download template.",
      },
    },
    {
      element: "[data-tour=add-question]",
      popover: {
        title: "Add question",
        description: "Click here to add question",
      },
    },
    {
      element: "[data-tour=show-options]",
      popover: {
        title: "Options",
        description: "Click here to update, delete, copy question",
      },
    },
    {
      element: "[data-tour=select-question-type]",
      popover: {
        title: "Select question type",
        description: "Click here to select question type",
      },
    },
    {
      element: "[data-tour=select-question-category]",
      popover: {
        title: "Select question category",
        description: "Click here to select question category",
      },
    },
    {
      element: "[data-tour=search-question]",
      popover: {
        title: "Search-question",
        description: "Click here to search question",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download data",
        description: "Download data for the this list page",
      },
    },
  ],
  "/questions-add": [
    {
      element: '[data-tour="upload-questions"]',
      popover: {
        title: "Upload question excel",
        description: "Click here to upload excel for question bulk import",
      },
    },
  ],
  "/questions/add": [
    {
      element: "[data-tour=fill-question-details]",
      popover: {
        title: "Fill out the necessary detail's for the question",
        description:
          "Provide the essential detail's required to create the question.",
      },
    },
    {
      element: "[data-tour=add-question-info]",
      popover: {
        title: "Save question",
        description: "Click here to save question",
      },
    },
  ],
  "/questions/edit": [
    {
      element: "[data-tour=fill-question-details]",
      popover: {
        title: "Update necessary details for the question",
        description:
          "Update the essential details required to create the question.",
      },
    },
    {
      element: "[data-tour=add-question-info]",
      popover: {
        title: "Update question",
        description: "Click here to update question",
      },
    },
  ],
  "/forms": [
    {
      element: "[data-tour=add-forms]",
      popover: {
        title: "Add forms",
        description: "Click here to add forms",
      },
    },
    {
      element: "[data-tour=show-options]",
      popover: {
        title: "Options",
        description: "Click here to update, delete, preview, copy survey form",
      },
    },
    {
      element: "[data-tour=search-forms]",
      popover: {
        title: "Search-forms",
        description: "Click here to search forms",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download data",
        description: "Download data for this list page",
      },
    },
  ],
  "/forms-add": [
    {
      element: "[data-tour=add-forms]",
      popover: {
        title: "Add forms",
        description: "Click here to add forms",
      },
    },
  ],
  "/forms/add": [
    {
      element: "[data-tour=fill-survey-details]",
      popover: {
        title: "Fill out the necessary details for the survey form",
        description:
          "Provide the essential details required to create the survey form.",
      },
    },
    {
      element: "[data-tour=add-form-info]",
      popover: {
        title: "Save form",
        description: "Click here to save survey form",
      },
    },
  ],
  "/forms/edit": [
    {
      element: "[data-tour=fill-survey-details]",
      popover: {
        title: "Update necessary details for the survey form",
        description:
          "Update the essential details required to create the survey form.",
      },
    },
    {
      element: "[data-tour=add-form-info]",
      popover: {
        title: "Update form",
        description: "Click here to update survey form",
      },
    },
  ],
  "/quiz": [
    {
      element: "[data-tour=add-forms]",
      popover: {
        title: "Add quiz",
        description: "Click here to add quiz",
      },
    },
    {
      element: "[data-tour=show-options]",
      popover: {
        title: "Options",
        description: "Click here to update, delete, preview Quiz",
      },
    },
    {
      element: "[data-tour=search-forms]",
      popover: {
        title: "Search quiz",
        description: "Click here to search quiz",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download data",
        description: "Download data for this list page",
      },
    },
  ],
  "/quiz-add": [
    {
      element: "[data-tour=add-forms]",
      popover: {
        title: "Add quiz",
        description: "Click here to add quiz",
      },
    },
  ],
  "/poll": [
    {
      element: "[data-tour=add-forms]",
      popover: {
        title: "Add poll",
        description: "Click here to add poll",
      },
    },
    {
      element: "[data-tour=show-options]",
      popover: {
        title: "Options",
        description: "Click here to update, delete poll",
      },
    },
    {
      element: "[data-tour=search-forms]",
      popover: {
        title: "Search poll",
        description: "Click here to search poll",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download data",
        description: "Download data for this list page",
      },
    },
  ],
  "/poll-add": [
    {
      element: "[data-tour=add-forms]",
      popover: {
        title: "Add poll",
        description: "Click here to add poll",
      },
    },
  ],
  "/poll/add": [
    {
      element: "[data-tour=add-poll-information]",
      popover: {
        title: "Fill out the necessary details for the poll",
        description:
          "Provide the essential details required to create the poll",
      },
    },
    {
      element: "[data-tour=add-poll-info]",
      popover: {
        title: "Save poll",
        description: "Click here to save poll",
      },
    },
  ],
  "/poll/edit": [
    {
      element: "[data-tour=add-poll-information]",
      popover: {
        title: "Update the necessary details for the poll",
        description:
          "Update the essential details required to create the poll",
      },
    },
    {
      element: "[data-tour=add-poll-info]",
      popover: {
        title: "Update poll",
        description: "Click here to update poll ",
      },
    },
  ],
  "/form-assignment": [
    {
      element: "[data-tour=add-assignment]",
      popover: {
        title: "Add assignment",
        description: "Click here to add assignment",
      },
    },
    {
      element: "[data-tour=show-options]",
      popover: {
        title: "Options",
        description:
          "Click here to Update, Delete, Publish, Track form, Show AssignedUser's, Update Date",
      },
    },
    {
      element: "[data-tour=search-assignment]",
      popover: {
        title: "Search-assignment",
        description: "Click here to search assignment",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download data",
        description: "Download data for this list page",
      },
    },
  ],
  "/form-assignment-add": [
    {
      element: "[data-tour=add-assignment]",
      popover: {
        title: "Add assignment",
        description: "Click here to add assignment",
      },
    },
  ],
  "/form-assignment/add": [
    {
      element: "[data-tour=select-survey-form]",
      popover: {
        title: "Select survey form",
        description: "Click here to select survey form",
      },
    },

    {
      element: "[data-tour=select-assessment]",
      popover: {
        title: "Select assessment",
        description: "Click here to select assessment type",
      },
    },

    {
      element: "[data-tour=start-date]",
      popover: {
        title: "Start date",
        description: "Click here to select start date",
      },
    },
    {
      element: "[data-tour=end-date]",
      popover: {
        title: "End date",
        description: "Click here to select end date",
      },
    },
    {
      element: "[data-tour=mark-public-survey]",
      popover: {
        title: "Public survey",
        description: "Click here to mark as public survey",
      },
    },
    {
      element: "[data-tour=search-user]",
      popover: {
        title: "Search user",
        description: "Search user to add in survey",
      },
    },
    {
      element: "[data-tour=move-to-selected]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from available list to selected list",
      },
    },
    {
      element: "[data-tour=move-to-available]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from selected list to available list",
      },
    },
    {
      element: "[data-tour=bulk-import]",
      popover: {
        title: "Import user",
        description: "Select excel file to bulk import user's for survey",
      },
    },
    {
      element: "[data-tour=save-assignment]",
      popover: {
        title: "Save assignment",
        description: "Click here to save survey assignment",
      },
    },
  ],
  "/form-assignment/edit": [
    {
      element: "[data-tour=select-survey-form]",
      popover: {
        title: "Select survey form",
        description: "Click here to select survey form",
      },
    },

    {
      element: "[data-tour=select-assessment]",
      popover: {
        title: "Select assessment",
        description: "Click here to select assessment type",
      },
    },

    {
      element: "[data-tour=start-date]",
      popover: {
        title: "Start date",
        description: "Click here to select start date",
      },
    },
    {
      element: "[data-tour=end-date]",
      popover: {
        title: "End date",
        description: "Click here to select end date",
      },
    },
    {
      element: "[data-tour=mark-public-survey]",
      popover: {
        title: "Public survey",
        description: "Click here to mark as public survey",
      },
    },
    {
      element: "[data-tour=search-user]",
      popover: {
        title: "Search user",
        description: "Search user to add in survey",
      },
    },
    {
      element: "[data-tour=move-to-selected]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from available list to selected list",
      },
    },
    {
      element: "[data-tour=move-to-available]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from selected list to available list",
      },
    },
    {
      element: "[data-tour=bulk-import]",
      popover: {
        title: "Import user",
        description: "Select excel file to bulk import user's for survey",
      },
    },
    {
      element: "[data-tour=save-assignment]",
      popover: {
        title: "Update assignment",
        description: "Click here to update survey assignment",
      },
    },
  ],
  "/form-assignment/poll": [
    {
      element: "[data-tour=add-assignment]",
      popover: {
        title: "Add assignment poll",
        description: "Click here to add assignment poll",
      },
    },
    {
      element: "[data-tour=show-options]",
      popover: {
        title: "Options",
        description:
          "Click here to Update, Delete, Publish, Track form, Show AssignedUser's, Update Date",
      },
    },
    {
      element: "[data-tour=search-assignment]",
      popover: {
        title: "Search assignment poll",
        description: "Click here to search assignment poll",
      },
    },
    {
      element: "[data-tour=download-data]",
      popover: {
        title: "Download data",
        description: "Download data for this list page",
      },
    },
  ],
  "/form-assignment/poll-add": [
    {
      element: "[data-tour=add-assignment]",
      popover: {
        title: "Add assignment poll",
        description: "Click here to add assignment poll",
      },
    },
  ],
  "/poll-assignment/add": [
    {
      element: "[data-tour=select-survey-form]",
      popover: {
        title: "Select poll",
        description: "Click here to select poll",
      },
    },

    {
      element: "[data-tour=select-start-time]",
      popover: {
        title: "Select start time",
        description: "Click here to select start time",
      },
    },

    {
      element: "[data-tour=select-end-time]",
      popover: {
        title: "Select end time",
        description: "Click here to select end time",
      },
    },
    {
      element: "[data-tour=search-user]",
      popover: {
        title: "Search user",
        description: "Search user to add in survey",
      },
    },
    {
      element: "[data-tour=move-to-selected]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from available list to selected list",
      },
    },
    {
      element: "[data-tour=move-to-available]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from selected list to available list",
      },
    },
    {
      element: "[data-tour=bulk-import]",
      popover: {
        title: "Import user",
        description: "Select excel file to bulk import user's for survey",
      },
    },
    {
      element: "[data-tour=save-assignment]",
      popover: {
        title: "Save poll assignment",
        description: "Click here to save poll survey assignment",
      },
    },
  ],
  "/poll-assignment/edit": [
    {
      element: "[data-tour=select-survey-form]",
      popover: {
        title: "Select poll",
        description: "Click here to select poll",
      },
    },

    {
      element: "[data-tour=select-start-time]",
      popover: {
        title: "Select start time",
        description: "Click here to select start time",
      },
    },

    {
      element: "[data-tour=select-end-time]",
      popover: {
        title: "Select end time",
        description: "Click here to select end time",
      },
    },
    {
      element: "[data-tour=search-user]",
      popover: {
        title: "Search user",
        description: "Search user to add in survey",
      },
    },
    {
      element: "[data-tour=move-to-selected]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from available list to selected list",
      },
    },
    {
      element: "[data-tour=move-to-available]",
      popover: {
        title: "Move user",
        description:
          "Transfer selected users from selected list to available list",
      },
    },
    {
      element: "[data-tour=bulk-import]",
      popover: {
        title: "Import user",
        description: "Select excel file to bulk import user's for survey",
      },
    },
    {
      element: "[data-tour=save-assignment]",
      popover: {
        title: "Update poll assignment",
        description: "Click here to save poll survey assignment",
      },
    },
  ],
  "/settings": [
    {
      element: "[data-tour=enable-captcha]",
      popover: {
        title: "Enable/disable captcha",
        description: "Click here to enable or disable captcha",
      },
    },
  ],
  "/template-user": [
    {
      element: "[data-tour=select-template]",
      popover: {
        title: "Select template",
        description: "Click here to select template",
      },
    },
  ],
};
